<!-- Модальная оболочка создания и редактирования позиции реестра грузов. -->
<template>
  <BaseModal
    :visible="visible"
    :title="title"
    size="xl"
    footer-align="start"
    elevated-footer
    adaptive-fullscreen
    @close="$emit('close')"
  >
    <CargoItemRegistryForm
      :form-id="formId"
      :initial-data="initialData"
      :is-loading="isLoading"
      :show-actions="false"
      @save="$emit('save', $event)"
      @cancel="$emit('close')"
    />

    <template #footer>
      <base-primary-button
        class="form-btn"
        type="submit"
        :form="formId"
        :disabled="isLoading"
      >
        {{ submitLabel }}
      </base-primary-button>
      <base-button
        class="form-btn"
        type="button"
        :disabled="isLoading"
        @click="$emit('close')"
      >
        Отмена
      </base-button>
    </template>
  </BaseModal>
</template>

<script>
import CargoItemRegistryForm from "@/components/Cargo/CargoItemRegistryForm.vue";

export default {
  name: "CargoItemRegistryModal",

  components: {
    CargoItemRegistryForm,
  },

  props: {
    initialData: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    submitLabel: {
      type: String,
      default: "Сохранить",
    },
    title: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["close", "save"],

  data() {
    return {
      formId: "cargo-item-registry-modal-form",
    };
  },
};
</script>
